import { inject, observer } from 'mobx-react';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Row } from 'reactstrap';

import { blockTestRender } from '../../../util/process';
import RightSidebarLayout from '../../layout/RightSidebarLayout';

const notTestRender = blockTestRender();

const CheckoutPageSkeleton = () => {
  if (!notTestRender) {
    return null;
  }

  return (
    <Row>
      <RightSidebarLayout
        className="CheckoutCartSkeleton"
        sidebarPlaceHolder={
          <Skeleton className="Skeleton__spacer" height={400} />
        }
      >
        <Skeleton className="Skeleton__spacer" height={300} />
        <Skeleton className="Skeleton__spacer" height={400} />
        <Skeleton className="Skeleton__spacer" height={600} />
      </RightSidebarLayout>
    </Row>
  );
};

export const CheckoutFormBenefitsSkeleton = () => {
  if (!notTestRender) {
    return null;
  }

  return (
    <div className="CheckoutFormBenefitsSkeleton">
      <Skeleton className="Skeleton__spacer" height={30} width={'30%'} />
      <Skeleton className="Skeleton__spacer" height={20} width={'60%'} />
      <Skeleton className="Skeleton__spacer" height={20} width={'55%'} />
      <Skeleton className="Skeleton__spacer" height={20} width={'65%'} />
      <Skeleton className="Skeleton__spacer" height={20} width={'80%'} />
    </div>
  );
};

export default inject(
  'categoryStore',
  'uiStore'
)(observer(CheckoutPageSkeleton));
